import React from 'react'
import './Hero.css'

const Hero = () => {
    return (
        <>
        <main className="page">
            <div className="hero">
                <div className="hero-container">
                    <div className="hero-text">
                        <h1>S@ck</h1>
                        <h4>If you love it, Buy it, otherwiswe someone else will! </h4>
                    </div>
                </div>
            </div>
        </main>
        </>
    )
}

export default Hero
